export const REQUEST_BUY_PRODUCT = 'product/REQUEST_BUY_PRODUCT';
export const REQUEST_FINISH_BUY = 'product/REQUEST_FINISH_BUY';
export const REQUEST_PRODUCT_OR_PLAN_BY_SLUG = 'product/REQUEST_PRODUCT_OR_PLAN_BY_SLUG';
export const REQUEST_PRODUCT_PLANS_BY_NAMESPACE = 'product/REQUEST_PRODUCT_PLANS_BY_NAMESPACE';
